import React from "react";
import "./helped.scss";
const Helped = function () {
  return (
    <div className="Helped">
      <section className="helping pt-6 mb-4" id="helping">
        <div className="container">
          <h2 className="text-center subHead mainColor">How we have helped</h2>
          <p className="text-center mainColor">
            See how Al Jalila Foundation have promoted change locally and to the
            world
          </p>
          <div className="container">
            <div
              id="multi-item-example"
              className="carousel slide carousel-multi-item pt-3"
              data-ride="carousel"
            >
              <div className="controls-top">
                <a
                  className="btn-floating prev"
                  href="#multi-item-example"
                  data-slide="prev"
                >
                  <img src="/imgs/banner/arrow/prevColor.png" alt="prev" />
                </a>
                <a
                  className="btn-floating next"
                  href="#multi-item-example"
                  data-slide="next"
                >
                  <img src="/imgs/banner/arrow/nextColor.png" alt="next" />
                </a>
              </div>
              <div className="carousel-inner" role="listbox">
                <div className="carousel-item active">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 clearfix d-none d-md-block">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 clearfix d-none d-md-block">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 clearfix d-none d-md-block">
                      <div className="card mb-2">
                        <div className="card-img-top">
                          <img src="/imgs/help/hat2.png" alt="Card image cap" />
                        </div>
                        <div className="card-body">
                          <div className="overlay"></div>
                          <div className="cardBG">
                            <h4 className="card-title">TA’ALOUF PROGRAM</h4>
                            <p className="number">200</p>
                            <p className="degree">
                              GRADUATES <strong>TO DATE</strong>
                            </p>
                            <p className="card-text">
                              Ta”alouf program aims to extend its reach across
                              the Emirates addressing the needs of the country.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Helped;
